(() => {
  function initialise(root) {
    if (root.dataset.builderInitialised === 'true') return;
    root.dataset.builderInitialised = 'true';
    const requiredCount = Number(root.dataset.requiredOils || 3);
    const isStarter = root.dataset.starter === 'true';
    const diffuserInputs = [...root.querySelectorAll('input[name="bundle-diffuser"]')];
    const oilCards = [...root.querySelectorAll('[data-oil-card]')];
    const categorySelect = root.querySelector('[data-oil-category-filter]');
    const categoryCount = root.querySelector('[data-category-count]');
    const collectionControls = root.querySelector('[data-collection-controls]');
    const exploreButton = root.querySelector('[data-explore-oils]');
    const oilGrid = root.querySelector('[data-oil-options]');
    const oilDialog = root.querySelector('[data-oil-dialog]');
    const dialogContent = root.querySelector('[data-oil-dialog-content]');
    const oilSearch = root.querySelector('[data-oil-search]');
    const noResults = root.querySelector('[data-oil-no-results]');
    const anyOilCard = root.querySelector('[data-any-oil-card]');
    const anyOilDescription = root.querySelector('[data-any-oil-description]');
    const controlsAnchor = document.createComment('Oil collection controls');
    const gridAnchor = document.createComment('Recommended oils');
    if (oilDialog) {
      collectionControls.before(controlsAnchor);
      oilGrid.before(gridAnchor);
    }
    const selectedDiffuserSummary = root.querySelector('[data-selected-diffuser]');
    const selectedOilsSummary = root.querySelector('[data-selected-oils]');
    const addButton = root.querySelector('[data-bundle-add]');
    const sticky = root.querySelector('[data-starter-sticky]');
    const stickyButton = root.querySelector('[data-sticky-buy]');
    const counter = root.querySelector('[data-oil-counter]');
    const total = root.querySelector('[data-bundle-total]');
    const totalSummary = root.querySelector('[data-bundle-total-summary]');
    const stickyTotal = root.querySelector('[data-sticky-total]');
    const message = root.querySelector('[data-bundle-message]');
    const upgradeLink = root.querySelector('[data-starter-upgrade]');
    const upgradeHref = upgradeLink?.getAttribute('href');
    let expanded = !isStarter;
    let busy = false;
    let comboCatalogue = null;
    const extraDiffusers = [];
    const comboHost = root.querySelector('[data-builder-combos]');
    const diffuserIds = () => [Number(selectedDiffuser()?.value), ...extraDiffusers];

    const selectedDiffuser = () => diffuserInputs.find(input => input.checked);
    const oilQuantity = card => Number(card.dataset.quantity || 0);
    const selectedCount = () => oilCards.reduce((sum, card) => sum + oilQuantity(card), 0);
    const selectedOils = () => oilCards.filter(card => oilQuantity(card) > 0).map(card => ({
      id: Number(card.dataset.variantId), quantity: oilQuantity(card)
    }));
    const currency = root.dataset.currency || 'GBP';
    const moneyFromCents = value => new Intl.NumberFormat('en-GB', {
      style: 'currency', currency, minimumFractionDigits: Number(value) % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
    }).format(Number(value || 0) / 100);
    const bundleTotal = () => extraDiffusers.length && comboCatalogue
      ? comboCatalogue.packagePrice(diffuserIds(), requiredCount)
      : Number(root.dataset.bundleBasePrice) +
      Number(selectedDiffuser()?.dataset.price || root.dataset.diffuserBasePrice) - Number(root.dataset.diffuserBasePrice);
    const ready = () => (!extraDiffusers.length || comboCatalogue?.resolve(diffuserIds())) && selectedCount() === requiredCount && selectedDiffuser() &&
      (!isStarter || selectedDiffuser().dataset.available === 'true') &&
      oilCards.filter(card => oilQuantity(card) > 0).every(card => card.dataset.oilAvailable !== 'false');
    const track = (name, details = {}) => {
      if (!isStarter || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const data = { product_id: root.dataset.productId, currency, value: bundleTotal() / 100, ...details };
      try {
        window.Shopify?.analytics?.publish?.(name, data);
        if (typeof window.gtag === 'function') window.gtag('event', name, data);
      } catch (_) {}
    };

    function applyCategoryFilter() {
      const category = categorySelect?.value || 'all';
      const search = oilSearch?.value.trim().toLocaleLowerCase() || '';
      let visibleCount = 0;
      oilCards.forEach(card => {
        const matches = expanded
          ? (category === 'all' || card.dataset.oilCategory === category) &&
            (!search || [card.dataset.oilName, card.dataset.oilInspiration].join(' ').toLocaleLowerCase().includes(search))
          : card.dataset.oilRecommended === 'true';
        card.closest('.bundle-builder__oil').hidden = !matches;
        if (matches) visibleCount += 1;
      });
      if (categoryCount) categoryCount.textContent = visibleCount + ' ' +
        (visibleCount === 1 ? categoryCount.dataset.singleLabel : categoryCount.dataset.pluralLabel);
      if (oilGrid && isStarter) oilGrid.dataset.recommendedView = String(!expanded);
      if (noResults) noResults.hidden = visibleCount > 0;
    }

    function setOilQuantity(card, requestedQuantity) {
      if (busy || card.dataset.oilAvailable === 'false') return;
      if (isStarter) {
        oilCards.forEach(item => { item.dataset.quantity = String(item === card && requestedQuantity > 0 ? 1 : 0); });
        message.textContent = '';
        track('starter_scent_selected', { scent_variant_id: card.dataset.variantId, scent_name: card.dataset.oilName });
      } else {
        const maximum = Math.max(0, requiredCount - selectedCount() + oilQuantity(card));
        card.dataset.quantity = String(Math.max(0, Math.min(requestedQuantity, maximum)));
      }
      applyCategoryFilter();
      refresh();
    }

    function refresh() {
      const count = selectedCount();
      const diffuser = selectedDiffuser();
      const price = moneyFromCents(bundleTotal());
      counter.textContent = count + ' / ' + requiredCount + ' selected';
      total.textContent = price;
      totalSummary.textContent = price;
      if (stickyTotal) stickyTotal.textContent = price;
      if (diffuser && selectedDiffuserSummary) selectedDiffuserSummary.textContent =
        diffuser.dataset.diffuserName + ' · ' + diffuser.dataset.variantTitle;
      const chosenCards = oilCards.filter(card => oilQuantity(card) > 0);
      if (selectedDiffuserSummary && extraDiffusers.length && comboCatalogue) {
        selectedDiffuserSummary.textContent += ' + ' + extraDiffusers.map(id => {
          const variant = comboCatalogue.devices.get(id);
          return 'Lumiscent ' + variant.model.name + ' · ' + variant.title;
        }).join(' + ');
      }
      comboHost?.querySelectorAll('button, select').forEach(control => { control.disabled = busy || !comboCatalogue; });
      root.querySelectorAll('.bundle-builder__retail, .lm-starter-header__compare').forEach(element => { element.hidden = extraDiffusers.length > 0; });
      if (upgradeLink && upgradeHref) {
        const upgradeUrl = new URL(upgradeHref, window.location.origin);
        if (diffuser) upgradeUrl.searchParams.set('lm_diffuser', diffuser.value);
        if (chosenCards[0]) upgradeUrl.searchParams.set('lm_oil', chosenCards[0].dataset.variantId);
        if (extraDiffusers.length) upgradeUrl.searchParams.set('lm_extra', extraDiffusers.join(','));
        upgradeLink.href = upgradeUrl.pathname + upgradeUrl.search;
      }
      if (selectedOilsSummary) selectedOilsSummary.textContent = chosenCards.length
        ? chosenCards.map(card => (oilQuantity(card) > 1 ? oilQuantity(card) + ' × ' : '') + card.dataset.oilName).join(', ')
        : selectedOilsSummary.dataset.emptyLabel;
      oilCards.forEach(card => {
        const quantity = oilQuantity(card);
        const unavailable = card.dataset.oilAvailable === 'false' ||
          (!isStarter && count >= requiredCount && quantity === 0);
        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-unavailable', unavailable);
        const stepper = card.querySelector('[data-oil-stepper]');
        const quantityValue = card.querySelector('[data-oil-quantity]');
        const increaseButton = card.querySelector('[data-oil-increase]');
        const decreaseButton = card.querySelector('[data-oil-decrease]');
        if (isStarter) {
          const choose = card.querySelector('[data-oil-choose]');
          card.setAttribute('role', 'group');
          card.removeAttribute('tabindex');
          card.removeAttribute('aria-disabled');
          if (choose) {
            choose.disabled = unavailable || busy;
            choose.setAttribute('aria-pressed', String(quantity > 0));
            choose.setAttribute('aria-label', (quantity > 0 ? root.dataset.selectedLabel : root.dataset.choiceLabel) + ': ' + card.dataset.oilName);
            choose.textContent = unavailable ? root.dataset.unavailableLabel :
              quantity > 0 ? root.dataset.selectedLabel + ' ✓' : root.dataset.choiceLabel;
          }
        } else {
          card.setAttribute('role', quantity === 0 ? 'button' : 'group');
          card.setAttribute('tabindex', quantity === 0 ? '0' : '-1');
          card.setAttribute('aria-disabled', String(unavailable || busy));
          const description = [card.dataset.oilName, card.dataset.oilInspiration].filter(Boolean).join(', ');
          card.setAttribute('aria-label', quantity === 0 ? 'Add ' + description + ' to your bundle' : description + ', quantity ' + quantity);
        }
        stepper.hidden = isStarter || quantity === 0;
        quantityValue.textContent = String(quantity);
        increaseButton.disabled = busy || unavailable || count >= requiredCount;
        decreaseButton.disabled = busy;
      });
      if (isStarter) {
        diffuserInputs.forEach(input => { input.disabled = busy || input.dataset.available !== 'true'; });
        if (exploreButton) exploreButton.disabled = busy;
        const diffuserImage = root.querySelector('.lm-starter-set-diffuser');
        if (diffuserImage && diffuser?.dataset.image && diffuserImage.getAttribute('src') !== diffuser.dataset.image) {
          diffuserImage.removeAttribute('srcset');
          diffuserImage.src = diffuser.dataset.image;
          diffuserImage.alt = diffuser.dataset.diffuserName + ' · ' + diffuser.dataset.variantTitle;
        }
        const oilImage = root.querySelector('[data-selected-oil-image]');
        const placeholder = root.querySelector('[data-selected-oil-placeholder]');
        const galleryScent = root.querySelector('[data-gallery-scent]');
        const chosen = chosenCards[0];
        if (oilImage) {
          const hasImage = Boolean(chosen?.dataset.oilImage);
          oilImage.hidden = !hasImage;
          if (placeholder) placeholder.toggleAttribute('hidden', hasImage);
          if (hasImage && oilImage.getAttribute('src') !== chosen.dataset.oilImage) {
            oilImage.src = chosen.dataset.oilImage;
            oilImage.alt = chosen.dataset.oilName;
          }
        }
        if (galleryScent && chosen) galleryScent.textContent = chosen.dataset.oilName + ' · 20ml';
        const customChoice = chosen && chosen.dataset.oilRecommended !== 'true';
        anyOilCard?.classList.toggle('is-selected', Boolean(customChoice));
        if (anyOilDescription) anyOilDescription.textContent = customChoice
          ? chosen.dataset.oilName + ' · 20ml selected' : anyOilDescription.dataset.defaultLabel;
        if (exploreButton) exploreButton.textContent = customChoice
          ? exploreButton.dataset.changeLabel : exploreButton.dataset.openLabel;
      }
      const diffuserUnavailable = isStarter && !diffuserInputs.some(input => input.dataset.available === 'true');
      addButton.disabled = busy || !ready();
      addButton.textContent = busy ? root.dataset.busyLabel : diffuserUnavailable ? root.dataset.unavailableLabel : ready()
        ? (requiredCount === 1 ? root.dataset.addLabel : 'Add bundle to bag')
        : (requiredCount === 1 ? root.dataset.selectLabel : 'Select ' + (requiredCount - count) + ' more oil' + (requiredCount - count === 1 ? '' : 's'));
      if (stickyButton) {
        stickyButton.disabled = busy || diffuserUnavailable;
        stickyButton.textContent = busy ? root.dataset.busyLabel : diffuserUnavailable ? root.dataset.unavailableLabel :
          ready() ? stickyButton.dataset.addLabel : stickyButton.dataset.chooseLabel;
      }
    }

    function focusScent() {
      const step = root.querySelector('[data-scent-step]');
      if (!step) return;
      step.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      step.focus({ preventScroll: true });
    }

    async function addBundle() {
      if (busy) return;
      if (!ready()) {
        message.textContent = root.dataset.notReadyLabel;
        focusScent();
        return;
      }
      const diffuser = selectedDiffuser();
      const oils = selectedOils();
      const items = [
        { id: extraDiffusers.length ? comboCatalogue.resolve(diffuserIds()).id : Number(diffuser.value), quantity: 1, properties: { _bundle: root.dataset.bundleName } },
        ...oils.map(oil => ({ id: oil.id, quantity: oil.quantity, properties: { _bundle: root.dataset.bundleName } }))
      ];
      busy = true;
      message.textContent = '';
      refresh();
      track('starter_add_requested', { diffuser_variant_id: diffuser.value, scent_variant_ids: oils.map(oil => String(oil.id)) });
      try {
        await window.LumiscentPurchaseCart.add(items, root);
        track('starter_bundle_added', { diffuser_variant_id: diffuser.value, scent_variant_ids: oils.map(oil => String(oil.id)) });
      } catch (_) {
        message.textContent = root.dataset.errorLabel;
      } finally {
        busy = false;
        refresh();
      }
    }

    diffuserInputs.forEach(input => input.addEventListener('change', () => {
      refresh();
      track('starter_colour_selected', { diffuser_variant_id: input.value });
    }));
    categorySelect?.addEventListener('change', applyCategoryFilter);
    oilSearch?.addEventListener('input', applyCategoryFilter);
    exploreButton?.addEventListener('click', () => {
      if (!oilDialog || busy) return;
      expanded = true;
      if (categorySelect) categorySelect.value = 'all';
      if (oilSearch) oilSearch.value = '';
      dialogContent.append(collectionControls, oilGrid);
      collectionControls.hidden = false;
      applyCategoryFilter();
      oilDialog.showModal();
      oilSearch?.focus({ preventScroll: true });
      track('starter_catalogue_toggled', { expanded: true });
    });
    root.querySelector('[data-close-oil-dialog]')?.addEventListener('click', () => oilDialog.close());
    oilDialog?.addEventListener('click', event => {
      if (event.target === oilDialog) oilDialog.close();
    });
    oilDialog?.addEventListener('close', () => {
      expanded = false;
      controlsAnchor.after(collectionControls);
      gridAnchor.after(oilGrid);
      collectionControls.hidden = true;
      applyCategoryFilter();
      exploreButton.focus({ preventScroll: true });
    });
    oilCards.forEach(card => {
      card.querySelector('[data-oil-decrease]').addEventListener('click', () => setOilQuantity(card, oilQuantity(card) - 1));
      card.querySelector('[data-oil-increase]').addEventListener('click', () => setOilQuantity(card, oilQuantity(card) + 1));
      card.querySelector('[data-oil-choose]')?.addEventListener('click', () => {
        if (busy || card.dataset.oilAvailable === 'false') return;
        setOilQuantity(card, 1);
        if (oilDialog?.open) oilDialog.close();
      });
      if (!isStarter) {
        card.addEventListener('click', event => {
          if (event.target.closest('button') || oilQuantity(card) > 0) return;
          setOilQuantity(card, 1);
        });
        card.addEventListener('keydown', event => {
          if (oilQuantity(card) > 0 || (event.key !== 'Enter' && event.key !== ' ')) return;
          event.preventDefault();
          setOilQuantity(card, 1);
        });
      }
    });
    addButton.addEventListener('click', addBundle);
    stickyButton?.addEventListener('click', () => ready() ? addBundle() : focusScent());
    if (sticky) {
      const query = window.matchMedia('(max-width: 749px)');
      const syncSticky = () => {
        sticky.hidden = !query.matches;
        document.body.classList.toggle('lm-starter-has-sticky', query.matches);
      };
      query.addEventListener('change', syncSticky);
      syncSticky();
    }
    const parameters = new URLSearchParams(window.location.search);
    const requestedDiffuser = diffuserInputs.find(input => input.value === parameters.get('lm_diffuser') && input.dataset.available !== 'false');
    if (requestedDiffuser) {
      diffuserInputs.forEach(input => { input.checked = input === requestedDiffuser; });
      requestedDiffuser.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const requestedOil = oilCards.find(card => card.dataset.variantId === parameters.get('lm_oil') && card.dataset.oilAvailable !== 'false');
    const defaultOil = requestedOil || (isStarter ? (
      oilCards.find(card => card.dataset.oilHandle === 'glorious-playground' && card.dataset.oilAvailable !== 'false') ||
      oilCards.find(card => card.dataset.oilRecommended === 'true' && card.dataset.oilAvailable !== 'false') ||
      oilCards.find(card => card.dataset.oilAvailable !== 'false')
    ) : null);
    if (defaultOil) {
      defaultOil.dataset.quantity = '1';
      if (!isStarter && categorySelect) categorySelect.value = 'all';
    }
    if (comboHost) {
      const initialiseComboChoices = () => window.LumiscentCombos.loadCatalogue(comboHost.dataset.catalogueUrl).then(catalogue => {
        comboCatalogue = catalogue;
        const labels = JSON.parse(comboHost.querySelector('[data-combo-labels]').textContent);
        const list = comboHost.querySelector('[data-extra-diffusers]');
        const add = comboHost.querySelector('[data-add-diffuser]');
        const node = (tag, text, className) => {
          const element = document.createElement(tag);
          if (text) element.textContent = text;
          if (className) element.className = className;
          return element;
        };
        const render = () => {
          list.replaceChildren();
          extraDiffusers.forEach((id, index) => {
            const variant = catalogue.devices.get(id);
            const card = node('div', undefined, 'lm-builder-combos__device');
            const heading = node('div', undefined, 'lm-builder-combos__heading');
            const image = node('img');
            image.src = variant.image;
            image.alt = 'Lumiscent ' + variant.model.name;
            image.width = 42;
            image.height = 42;
            heading.append(image, node('span', index === 0 ? labels.second : labels.third));
            const remove = node('button', labels.remove);
            remove.type = 'button';
            remove.addEventListener('click', () => { if (!busy) { extraDiffusers.splice(index, 1); render(); } });
            heading.append(remove);
            const controls = node('div', undefined, 'lm-builder-combos__controls');
            const modelLabel = node('label', labels.model);
            const modelSelect = node('select');
            modelSelect.setAttribute('aria-label', (index === 0 ? labels.second : labels.third) + ': ' + labels.model);
            Object.entries(catalogue.models).forEach(([key, model]) => {
              const option = node('option', model.name);
              option.value = key;
              modelSelect.append(option);
              if (model === variant.model) modelSelect.value = key;
            });
            modelLabel.append(modelSelect);
            const colourLabel = node('label', labels.colour);
            const colourSelect = node('select');
            colourSelect.setAttribute('aria-label', (index === 0 ? labels.second : labels.third) + ': ' + labels.colour);
            colourLabel.append(colourSelect);
            const fillColours = () => {
              colourSelect.replaceChildren();
              const model = catalogue.models[modelSelect.value];
              model.variants.filter(colour => colour.available).forEach(colour => {
                const option = node('option', colour.title.replace(/ Fabric| Reeded Aluminium| Aluminium/g, ''));
                option.value = colour.id;
                colourSelect.append(option);
              });
              if (model.variants.some(colour => colour.id === extraDiffusers[index] && colour.available)) colourSelect.value = String(extraDiffusers[index]);
              extraDiffusers[index] = Number(colourSelect.value);
              const selected = catalogue.devices.get(extraDiffusers[index]);
              if (selected) { image.src = selected.image; image.alt = 'Lumiscent ' + selected.model.name; }
            };
            const showSelectedColour = () => root.dispatchEvent(new CustomEvent('lumiscent:colour-selected', {
              bubbles: true, detail: { variant: String(extraDiffusers[index]) }
            }));
            modelSelect.addEventListener('change', () => { fillColours(); refresh(); showSelectedColour(); });
            colourSelect.addEventListener('change', () => {
              extraDiffusers[index] = Number(colourSelect.value);
              image.src = catalogue.devices.get(extraDiffusers[index]).image;
              refresh();
              showSelectedColour();
            });
            fillColours();
            controls.append(modelLabel, colourLabel);
            card.append(heading, controls);
            list.append(card);
          });
          add.hidden = extraDiffusers.length >= 2;
          add.textContent = (extraDiffusers.length ? labels.addThird : labels.addSecond) + ' ›';
          refresh();
        };
        parameters.get('lm_extra')?.split(',').map(Number).filter(id => catalogue.devices.get(id)?.available).slice(0, 2).forEach(id => extraDiffusers.push(id));
        add.addEventListener('click', () => {
          if (busy || extraDiffusers.length >= 2) return;
          extraDiffusers.push(Number(selectedDiffuser().value));
          render();
        });
        render();
      }).catch(() => { comboHost.hidden = true; });
      if (window.LumiscentCombos) initialiseComboChoices();
      else document.addEventListener('lumiscent:combos-ready', initialiseComboChoices, { once: true });
    }
    applyCategoryFilter();
    refresh();
    track('starter_landing_view');
  }
  document.querySelectorAll('[data-bundle-builder]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-bundle-builder]').forEach(initialise);
  });
})();

